import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Typography } from '@mui/material';
import React from 'react';
const colors = {
    default: themeColors.text.main,
    red: themeColors.accent.red.bold,
};
export const RemainingTime = ({ startTime, variant = 'default' }) => {
    const [timeUntilShiftStart, setTimeUntilShiftStart] = React.useState();
    React.useEffect(() => {
        const updatedTimeUntilShiftStart = getTimeUntilShiftStart(Date.now(), startTime);
        if (updatedTimeUntilShiftStart !== timeUntilShiftStart) {
            setTimeUntilShiftStart(getTimeUntilShiftStart(Date.now(), startTime));
        }
    }, [startTime, timeUntilShiftStart]);
    return (React.createElement(Typography, { variant: 'subtitle1', color: colors[variant], "data-test": 'remaining-time' }, timeUntilShiftStart));
};
function getTimeUntilShiftStart(currentTime, startTime) {
    const diffTime = startTime - currentTime;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
    return diffTime > 0 ? `${diffDays}d ${diffHours}h ${diffMinutes}m` : '0d 0h 0m';
}
